import Vue from "vue";
import Router from "vue-router";

import MainPage from "../components/layout/MainPage.vue";
import MainLayout from "../components/layout/MainLayout.vue";

import IntroLayout from "../components/layout/IntroLayout.vue";
import Login from "../components/layout/Login.vue";

import CompanyMain from "../components/sub01/CompanyMain.vue";
import VisionTab from "../components/sub01/VisionTab.vue";
import HistoryTab from "../components/sub01/HistoryTab.vue";
import CeoTab from "../components/sub01/CeoTab.vue";
import MainNetworkTab from "../components/sub01/NetworkTab.vue";
import CiTab from "../components/sub01/CiTab.vue";
import Ethics from "../components/sub01/Ethics.vue";
import Principle from "../components/sub01/Principle.vue";

import PersonalPolicy from "../components/footer/PersonalPolicy.vue";

import Test1 from "../components/layout/test1.vue";

import Email from "../components/footer/Email.vue";

import BizMain from "../components/sub02/BizMain.vue";

import Ferrumclub from "../components/sub02/Ferrumclub.vue";
import FerrumTower from "../components/sub02/FerrumTower.vue";
import Mro from "../components/sub02/Mro.vue";
import FerrumReserve from "../components/sub02/FerrumReserve.vue";

import FerrumReservePopup from "../components/sub02/FerrumReservePopup.vue";

import PublicMain from "../components/sub03/PublicMain.vue";
import News from "../components/sub03/News.vue";
import NewsDetail from "../components/sub03/NewsDetail";

import NewsWritePopup from "../components/sub03/NewsWritePopup.vue";
import PRVideo from "../components/sub03/PRVideo.vue";

import ManagementMain from "../components/sub04/ManagementMain.vue";
import Talent from "../components/sub04/Talent.vue";
import Personnel from "../components/sub04/Personnel.vue";
import Recruitment from "../components/sub04/Recruitment.vue";

import InvestMain from "../components/sub05/InvestMain.vue";
import finance from "../components/sub05/finance.vue";
import NotiList from "../components/sub05/NotiList.vue";
import writeNoti from "../components/sub05/writeNoti.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/main",
      component: MainLayout,
      children: [
        {
          path: "main",
          component: MainPage,
          name: "MainPage"
        },
        {
          path: "Email",
          component: Email
        },
        {
          path: "PersonalPolicy",
          component: PersonalPolicy
        },
        {
          path: "Company",
          component: CompanyMain,
          children: [
            {
              path: "CEO",
              component: CeoTab
            },
            {
              path: "Principle",
              component: Principle
            },
            {
              path: "Vision",
              component: VisionTab
            },
            {
              path: "History",
              component: HistoryTab
            },

            {
              path: "Network",
              component: MainNetworkTab
            },
            {
              path: "CI",
              component: CiTab
            },
            {
              path: "Ethics",
              component: Ethics
            }
          ]
        },
        {
          path: "Biz",
          component: BizMain,
          children: [
            {
              path: "Club",
              component: Ferrumclub
            },
            {
              path: "MRO",
              component: Mro
            },
            {
              path: "Tower",
              component: FerrumTower
            },
            {
              path: "Reserve",
              component: FerrumReserve,
              children: [
                {
                  path: "ReservePopup",
                  component: FerrumReservePopup
                }
              ]
            }
          ]
        },

        {
          path: "Public",
          component: PublicMain,
          children: [
            {
              path: "News",
              component: News,
              children: [
                {
                  path: "NewsWritePopup",
                  component: NewsWritePopup
                }
              ]
            },
            {
              path: "NewsDetail/:id",
              component: NewsDetail,
              children: [
                {
                  path: "NewsWritePopup",
                  component: NewsWritePopup
                }
              ]
            },
            {
              path: "PRVideo",
              component: PRVideo
            }
          ]
        },
        {
          path: "Management",
          component: ManagementMain,
          children: [
            {
              path: "Talent",
              component: Talent
            },
            {
              path: "Personnel",
              component: Personnel
            },
            {
              path: "Recruitment",
              component: Recruitment
            }
          ]
        },
        {
          path: "Invest",
          component: InvestMain,
          children: [
            {
              path: "finance",
              component: finance
            },
            {
              path: "NotiList",
              component: NotiList,
              children: [
                {
                  path: "writeNoti/:write",
                  component: writeNoti
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/Intro",
      component: IntroLayout,
      children: [
        {
          path: "/Login",
          component: Login
        }
      ]
    },

    {
      path: "/test",
      component: Test1
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
    // 원하는 위치로 돌아가기
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js